<template>
  <BaseLayout
    theme-header="small"
    theme-footer="small"
  >
    <slot />
  </BaseLayout>
</template>

<script setup lang="ts">
import { watch, computed } from 'vue';
import { useRouter } from '#imports';
import { storeToRefs } from 'pinia';
import BaseLayout from '~/components/base-layout.vue';
import { useCartStore } from '~/stores/cart';

const router = useRouter();

const { cartIsEmpty, cartInitialized } = storeToRefs(useCartStore());

const isCartEmpty = computed(() => cartIsEmpty.value && cartInitialized.value);

watch(
  isCartEmpty,
  (value) => {
    if (value) {
      router.replace('/shop/warenkorb');
    }
  },
  { immediate: true }
);
</script>
